import { createApp, readonly, ref, unref } from 'vue'
import App from './App.vue'

import { setup as setupAccessToken, useAccessToken } from '@/composables/useAccessToken'
import { setup as setupIdentity } from '@/composables/useIdentity'
import { setup as setupBranches, useBranches } from '@/composables/useBranches'

const initialized = ref(false)

const setupFBAPI = () => Promise.race([
	new Promise((_) => $(document).one('FB:inited', _)),
	new Promise<void>((_) => typeof FB !== 'undefined' ? _() : null)
])

const setupFBCustomerChatAPI = () => Promise.race([
	new Promise<void>((resolve) => {
		const check = () => {
			if (FB && 'CustomerChat' in FB) {
				return resolve()
			}
			setTimeout(check, 600)
		}
		check()
	}),
	new Promise<void>((_) => setTimeout(_, 6000)),
])

;(async () => {
	await setupFBAPI()

	await setupBranches()
	$(document).trigger('vueApp:loaded:branches', [unref(useBranches())])

	await setupAccessToken()
	const { accessToken } = useAccessToken()
	if (accessToken) {
		await setupIdentity(accessToken)
	}

	initialized.value = true
})()

createApp(App)
	.provide('appInitialized', readonly(initialized))
	.mount('#app')
